import * as types from "./actionTypes";
import SubscriptionStatus from '../../subscription/models/SubscriptionStatus'

export const loadSubscriptionSuccess = (subscriptions: SubscriptionStatus[]) => {
  return { type: types.LOAD_SUBSCRIPTIONS_SUCCESS, subscriptions };
}

export const loadSubscriptionStart = (asset: string, enviromentId: number, page?: number, pagesize?: number) => {
  return { type: types.START_LOAD_SUBSCRIPTION, asset, enviromentId, page, pagesize };
}



// WEBPACK FOOTER //
// ./src/modules/core/actions/subscriptionActions.tsx